export enum AppointmentStatus {
  PENDING,
  CONFIRMED,
  CANCELLED
}
